<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import BlogHeading from '@/Pages/Blogs/Partials/BlogHeading.vue'
import BlogParagraph from '@/Pages/Blogs/Partials/BlogParagraph.vue'
import BlogImage from '@/Pages/Blogs/Partials/BlogImage.vue'
import HeadingOne from '@/Components/HeadingOne.vue'
import Paragraph from '@/Components/Paragraph.vue'

const props = defineProps({
    blog: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <AppLayout
        :meta_title="blog.relationships?.seo?.title || blog.title"
        :meta_description="blog.relationships?.seo?.description || blog.subtitle"
    >
        <template #content>
            <section class="section--width sm:!py-10">
                <div class="rounded-lg bg-zinc-800 px-6 py-10">
                    <div class="mx-auto max-w-3xl text-base/7 text-gray-700">
                        <header>
                            <h1
                                class="font-roboto mt-10 py-1 text-center text-6xl leading-[4rem] font-bold tracking-wide text-pretty text-white uppercase sm:text-5xl lg:text-left"
                            >
                                {{ blog.title }}
                            </h1>

                            <Paragraph :value="blog.subtitle" />
                        </header>

                        <div class="mt-10">
                            <div
                                v-for="(content, index) in blog.content"
                                :key="index"
                            >
                                <BlogHeading
                                    v-if="content.type === 'heading'"
                                    :content="content.data"
                                />

                                <BlogParagraph
                                    v-else-if="content.type === 'paragraph'"
                                    :content="content.data.content"
                                />

                                <BlogImage
                                    v-else-if="content.type === 'image'"
                                    :value="content.data"
                                />

                                <div v-else>
                                    {{ content.type }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </AppLayout>
</template>
